import React from "react";
import { Container, Card, Row, Col, Button } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={8} className="mx-auto">
          <Card>
            <Card.Header as="h5" className="bg-success text-white">
              Member Dashboard
            </Card.Header>
            <Card.Body>
              <h4>Welcome, {currentUser?.displayName || "User"}!</h4>

              <div className="my-4">
                <h5>Your Profile Information:</h5>
                <ul className="list-unstyled">
                  <li>
                    <strong>Email:</strong> {currentUser?.email}
                  </li>
                  <li>
                    <strong>Email Verified:</strong>{" "}
                    {currentUser?.emailVerified ? (
                      <span className="text-success">✓ Yes</span>
                    ) : (
                      <span className="text-warning">⚠ No</span>
                    )}
                  </li>
                  {/* <li><strong>User ID:</strong> {currentUser?.uid}</li>
                  <li><strong>Provider:</strong> {currentUser?.providerData[0]?.providerId}</li> */}
                </ul>
              </div>

              {currentUser?.photoURL && (
                <div className="my-3">
                  <img
                    src={currentUser.photoURL}
                    alt="Profile"
                    className="rounded-circle"
                    style={{ width: "60px", height: "60px" }}
                  />
                </div>
              )}

              <div className="alert alert-info" role="alert">
                <p>
                  <strong>🎉 Success!</strong> Welcome to the members dashboard.
                </p>
                <p>
                  <strong>Currently Available:</strong>
                  <br />
                  💀{" "}
                  <a href="./forbidden-lands-campaign-maps">
                    The Forbidden Lands Maps (super-high resolution with hex
                    number overlays)
                  </a>{" "}
                  💀
                </p>
                <p>
                  Soon we will have free, members-only gaming materials
                  available such as:
                  <br />
                  <em>The Districts of Doskvol for Blades in the Dark</em>.
                </p>
                <p>
                  We will notify you when more free, members-only gaming
                  materials!
                </p>
              </div>

              <div className="d-flex gap-2">
                <Button variant="primary" onClick={() => navigate("/")}>
                  Go to Home
                </Button>
                <Button variant="outline-danger" onClick={handleLogout}>
                  Sign Out
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
